
import { useEffect, useState } from "react";

import { useDispatch } from 'react-redux';

import { useSelector } from "react-redux";

import { useNavigate } from "react-router";

import { Avatar, Box, Button, ButtonGroup, Card, CardActions, CardContent, CardHeader, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, Table, TableFooter, TablePagination, TableRow, Typography } from "@mui/material"

import DeskIcon from '@mui/icons-material/Desk';
import UndoIcon from '@mui/icons-material/Undo';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

import { RootState } from "../../store";
import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { usePages } from "../../hooks/usePages";
import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { ObtenerEstatus } from "../../connections/catalogos/EstatusConnection";
import { ObtenerUnidades } from "../../connections/catalogos/UnidadConnection";
import { ObtenerUsuarioUnidad } from "../../connections/admin/UsuarioConnection";
import { ConsultaCubiculos, ConsultaCubiculosFiltros, LiberarCubiculo, OcuparCubiculo } from "../../connections/comun/CubiculosConnection";

import { EstatusProps } from "../../interfaces/catalogos/EstatusInterface";
import { UnidadProps } from "../../interfaces/catalogos/UnidadInterface";
import { UsuarioProps } from "../../interfaces/admin/UsuarioInterface";
import { CubiculosProps, defaultCubiculo, ObtenerCubiculoParams } from "../../interfaces/comun/CubiculosInterface";

export const HomePage = () => {
    
    const dispatch = useDispatch();
    
    const navigate = useNavigate();
    
    const { administrador } = useSelector((state: RootState) => state.auth);

    const [open, setOpen] = useState(false);

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(12);

    const [rows, setRows] = useState<CubiculosProps[]>([])
    const [rowsAll, setRowsAll] = useState<CubiculosProps[]>([])

    const [loading, setLoading] = useState(true);
    const [loadingFinalizar, setLoadingFinalizar] = useState(false);
    const [loadingLiberar, setLoadingLiberar] = useState(false);

    const [reload, setReload] = useState(false);

    const [estatusArray, setEstatusArray] = useState<EstatusProps[]>([]);
    const [estatus, setEstatus] = useState(0);

    const [unidadArray, setUnidadArray] = useState<UnidadProps[]>([]);
    const [unidad, setUnidad] = useState(0);
    const [unidadAsignacion, setUnidadAsignacion] = useState(0);

    const [usuarioArray, setUsuarioArray] = useState<UsuarioProps[]>([]);
    const [usuarioAsignacion, setUsuarioAsignacion] = useState(0);

    const [filtroAplicado, setFiltroAplicado] = useState(false);

    const [cubiculoSeleccionado, setCubiculoSeleccionado] = useState<CubiculosProps>( defaultCubiculo );
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const handleBuscarCubiculos = async (idEstatus?: number) => {

        setFiltroAplicado(true);
        setLoading(true);
        setRows([]);

        const params = {
            idEstatus: (administrador) ? estatus : idEstatus ?? 0,
            idUnidad: (administrador) ? unidad : 0
        }

        await ConsultaCubiculosFiltros(params).then(resp => {

            setTimeout(() => {
                
                setRows(resp);
                setLoading(false);

            }, 700);

        });

    };

    const handleClearFiltro = async () => {

        setUnidad( 0 );
        setEstatus( 0 );
      
        setFiltroAplicado( false );

        setLoading( true );

        setRows( [] );

        await ConsultaCubiculos().then( resp => {

            setTimeout(() => {
        
                setRows( resp );
                setRowsAll( resp );
                setLoading( false );
                resetPage();
                
            }, 700);

        });

    };

    const handleSeleccionarCubiculo = (value: CubiculosProps) => {

        setCubiculoSeleccionado(value);
        setConfirmDialogOpen(true);

    };

    const confirmarSeleccionCubiculo = async () => {

        setLoadingFinalizar(true);

        const params: ObtenerCubiculoParams = {

            idTipoCubiculo: cubiculoSeleccionado.idTipoCubiculo ?? 0,
            idUsuario: administrador ? usuarioAsignacion : 0,
            idUnidad: administrador ? unidadAsignacion : 0,
        };

        await OcuparCubiculo( params ).then(resp => {

            setTimeout(() => {
                
                const { success, message, idTipoCubiculo, numeroCubiculo, liberar, idEstatus, estatus, idUnidad, unidad, usuario } = resp;
    
                if ( success ) {
    
                    setReload( true );
                    setConfirmDialogOpen( false );
    
                    setUsuarioAsignacion( 0 );
                    setUnidadAsignacion( 0 );
    
                    setLoadingFinalizar( false );

                    dispatch( openSnackbar({ message: message, variant: 'success' }));     
    
                }
                else {      
    
                    setLoadingFinalizar( false );
    
                    if( idTipoCubiculo && idTipoCubiculo !== 0 ){
    
                        const newArray = rows.map((elem) => {
            
                            if (elem.idTipoCubiculo === cubiculoSeleccionado.idTipoCubiculo) {
                                elem = { idTipoCubiculo, numeroCubiculo, liberar, idEstatus, estatus, idUnidad, unidad, usuario, };
                            }
        
                            return elem;
                        });
        
                        setRows( newArray );
                        setRowsAll( newArray );
    
                    }
    
                    setUsuarioAsignacion( 0 );
                    setUnidadAsignacion( 0 );
                    setConfirmDialogOpen( false );
    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));     
    
                }

            }, 700);

        });

    };

    const handleLiberarCubiculo = (value: CubiculosProps) => {

        setCubiculoSeleccionado( value );
        setOpen( true );

    };

    const confirmarLiberacionCubiculo = async () => {

        setLoadingLiberar(true);

        await LiberarCubiculo({ idTipoCubiculo: cubiculoSeleccionado.idTipoCubiculo ?? 0 }).then(resp => {

            setTimeout(() => {
                
                const { success, message } = resp;
    
                if ( success ) {
    
                    setReload( true );
                    setConfirmDialogOpen( false );
                    setLoadingLiberar( false );
                    setOpen( false );
                   
                    dispatch( openSnackbar({ message: message, variant: 'success' }));     
    
                }
                else {                    
                    
                    setLoadingLiberar( false );
                    setOpen( false );
    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));     
    
                }

            }, 700);

        });

    };

    useEffect(() => {

        async function obtener() {

            setLoading(true);
            setRows([]);

            await ConsultaCubiculos().then(resp => {

                setTimeout(() => {
                    
                    setRows( resp );
                    setRowsAll( resp );
                    setLoading( false );

                }, 700);
            });

        }

        obtener();

    }, []);

    useEffect(() => {

        async function obtener() {

            setLoading( true );
            setRows( [] );

            await ConsultaCubiculos().then(resp => {

                setTimeout(() => {
                    
                    setRows( resp );
                    setRowsAll( resp );
                    setLoading( false );
                    setReload( false );

                }, 700);
            });

        }

        if( reload ){
            obtener();
        }

    }, [ reload ]);

    useEffect(() => {

        async function obtener() {

            await ObtenerEstatus().then(resp => {
                setEstatusArray(resp);
            });
        }

        obtener();

    }, []);

    useEffect(() => {

        async function obtener() {

            await ObtenerUnidades().then(resp => {
                setUnidadArray(resp);
            });
        }

        obtener();

    }, []);

    useEffect(() => {

        async function obtener() {

            if (unidadAsignacion > 0) {

                await ObtenerUsuarioUnidad(unidadAsignacion).then(resp => {
                    setUsuarioArray(resp);
                });
            }
        }

        obtener();

    }, [unidadAsignacion]);

    return (

        <Layout breadcrumbs={[{ text: 'Gestionar cubículos' }]} backgroundPaper={false}>

            <Grid container spacing={3}>

                {
                    administrador
                    &&
                        <>

                            <Grid size={{ xs: 12 }} textAlign={'start'}>

                                <Button color="secondary" startIcon={ <UndoIcon />} onClick={() => navigate('/')}>
                                    Regresar
                                </Button>

                            </Grid>

                            <Grid size={{ xs: 12, md: 12 }}>

                                <Card>

                                    <CardHeader 
                                        sx={{ backgroundColor: (theme) => theme.palette.primary.main }} 
                                        subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Filtro(s) </Typography> }
                                    />

                                    <CardContent sx={{ p: 3 }}>

                                        <Grid container spacing={3}>

                                            <Grid size={{ xs: 12, md: 6 }}>

                                                <FormControl fullWidth disabled={loading}>

                                                    <InputLabel>Unidad</InputLabel>

                                                    <Select                                                      
                                                        label="Unidad"
                                                        value={ unidad }
                                                        onChange={(e) => { setEstatus(0); setUnidad( parseInt(e.target.value.toString() ?? "0") ); }}
                                                        disabled={ filtroAplicado }
                                                    >
                                                        <MenuItem key={0} value={0}>Todas las unidades</MenuItem>
                                                        {
                                                            unidadArray.map((u) => (
                                                                <MenuItem key={u.idUnidad} value={u.idUnidad}>
                                                                    {u.descripcion}
                                                                </MenuItem>
                                                            ))
                                                        }
                                                    </Select>

                                                </FormControl>

                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>

                                                <FormControl fullWidth disabled={loading}>

                                                    <InputLabel>Estatus</InputLabel>

                                                    <Select
                                                        label="Estatus"
                                                        value={ estatus }
                                                        onChange={ (e) => setEstatus(parseInt(e.target.value.toString() ?? "0"))}
                                                        disabled={ filtroAplicado }
                                                    >
                                                        <MenuItem key={0} value={0}>Todas los estatus</MenuItem>
                                                        {
                                                            unidad !== 0
                                                            ?
                                                                estatusArray
                                                                    .filter((e) => e.idEstatus !== 1 && e.idEstatus !== 2 && e.idEstatus !== 3)
                                                                    .map((e) => (
                                                                        <MenuItem key={e.idEstatus} value={e.idEstatus}>
                                                                            {e.descripcion}
                                                                        </MenuItem>
                                                                    ))
                                                            :
                                                                estatusArray
                                                                    .filter((e) => e.idEstatus !== 1 && e.idEstatus !== 2)
                                                                    .map((e) => (
                                                                        <MenuItem key={e.idEstatus} value={e.idEstatus}>
                                                                            {e.descripcion}
                                                                        </MenuItem>
                                                                    ))
                                                        }
                                                    </Select>


                                                </FormControl>

                                            </Grid>

                                            <Grid>

                                                <Button
                                                    type="button"
                                                    fullWidth
                                                    variant={filtroAplicado ? "contained" : "contained"}
                                                    color={filtroAplicado ? "inherit" : "primary"}
                                                    startIcon={filtroAplicado ? <ClearIcon /> : <SearchIcon />}
                                                    onClick={() => filtroAplicado ? handleClearFiltro() : handleBuscarCubiculos()}
                                                    disabled={unidad === 0 && estatus === 0}
                                                >
                                                    {filtroAplicado ? 'limpiar filtro' : 'Buscar'}
                                                </Button>

                                            </Grid>

                                        </Grid>

                                    </CardContent>

                                </Card>

                            </Grid>

                        </>
                }

                {
                    !administrador
                    &&
                        <Grid size={{ xs: 12, md: administrador ? 6 : 12 }}>

                            <ButtonGroup fullWidth>

                                <Button 
                                    variant="contained"
                                    color={ rowsAll.length === 0 ? 'inherit' : "primary" } 
                                    disabled={ loading || rowsAll.length === 0 }
                                    onClick={ () => handleBuscarCubiculos( 0 ) }
                                >
                                    Todos los cubículo ({ rowsAll.length })
                                </Button>

                                <Button
                                    variant="contained"
                                    color={ rowsAll.filter( (e) => e.idEstatus === 3 ).length === 0 ? 'inherit' : "success" }
                                    disabled={ loading || rowsAll.filter( (e) => e.idEstatus === 3 ).length === 0 }
                                    onClick={ () => handleBuscarCubiculos( 3 ) }
                                >
                                    Disponibles ({ rowsAll.filter( (e) => e.idEstatus === 3 ).length })
                                </Button>

                                <Button
                                    variant="contained"
                                    color={ rowsAll.filter( (e) => e.idEstatus === 4 ).length === 0 ? 'inherit' : "error" }
                                    disabled={ loading || rowsAll.filter( (e) => e.idEstatus === 4 ).length === 0 }
                                    onClick={ () => handleBuscarCubiculos( 4 ) }
                                >
                                    Ocupados ({ rowsAll.filter( (e) => e.idEstatus === 4 ).length })
                                </Button>

                                <Button
                                    variant="contained"
                                    color={ rowsAll.filter( (e) => e.idEstatus === 5 ).length === 0 ? 'inherit' : "warning" }
                                    disabled={ loading || rowsAll.filter( (e) => e.idEstatus === 5 ).length === 0 }
                                    onClick={ () => handleBuscarCubiculos( 5 ) }
                                >
                                    En uso ({ rowsAll.filter( (e) => e.idEstatus === 5 ).length })
                                </Button>
                      
                                <Button
                                    variant="contained"
                                    color={ rowsAll.filter( (e) => e.idEstatus === 6 ).length === 0 ? 'inherit' : "secondary" }
                                    disabled={ loading || rowsAll.filter( (e) => e.idEstatus === 6 ).length === 0 }
                                    onClick={ () => handleBuscarCubiculos( 6 ) }
                                >
                                    En espera ({ rowsAll.filter( (e) => e.idEstatus === 6 ).length })
                                </Button>

                            </ButtonGroup>

                        </Grid>
                }

                {
                    loading
                    &&
                        <Box textAlign={'center'} width={'100%'} mt={10} >
                            <CircularProgress />
                        </Box>
                }

                {
                    ( !loading && rows.length !== 0 )
                    &&
                        <Grid size={{ xs: 12 }} sx={{ justifyItems: 'end' }}>
                            <Table>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            sx={{ border: 'none' }}
                                            rowsPerPageOptions={[6, 12, 24, 48, 120]}
                                            count={rows.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                            labelRowsPerPage="Filas por página"
                                            labelDisplayedRows={
                                                ({ from, to, count }) => {
                                                    return '' + from + '-' + to + ' de ' + count
                                                }
                                            }
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Grid>
                }

                {
                    ( !loading && rows.length === 0 )
                    &&
                        <Box textAlign={'center'} width={'100%'} mt={10} >
                            <Typography>No se encontraron cubículos</Typography>
                        </Box>
                }

                {
                    (
                        rowsPerPage > 0
                            ?
                            rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            :
                            rows
                    )
                        .map(({ idTipoCubiculo, numeroCubiculo, idEstatus, unidad, usuario, liberar }) => (

                            <Grid key={numeroCubiculo} size={{ xs: 12, sm: 4, md: 3, lg: 2 }}>

                                <Card>

                                    <CardHeader
                                        avatar={<Chip icon={<DeskIcon />} label={`Cubículo ${numeroCubiculo}`} variant="outlined" />}
                                        action={
                                            <Chip
                                                size="small"
                                                label={<Typography fontSize={12} sx={{ color: 'transparent' }}> ¬ </Typography>}
                                                color={
                                                    idEstatus === 4
                                                    ?
                                                        "error"
                                                    :
                                                        idEstatus === 5
                                                        ?
                                                            "warning"
                                                        :
                                                            idEstatus === 6
                                                            ?
                                                                "secondary"
                                                            :
                                                                "success"
                                                }
                                            />
                                        }
                                    />

                                    <Box justifyItems={'center'}>

                                        <Avatar
                                            src={process.env.PUBLIC_URL + "/assets/imagen-cubiculo-small.png"}
                                            variant="rounded"
                                            sx={{ width: 240, height: 220, padding: "1em 1em 0 1em", objectFit: "contain" }}
                                        />

                                    </Box>

                                    {
                                        ( idEstatus === 4 || idEstatus === 5 || idEstatus === 6 )
                                        &&
                                            <CardContent sx={{ height: ( idEstatus === 4 || idEstatus === 5 ) ? 100 : 70 }}>

                                                <Typography variant="h6" fontSize={14}>
                                                    Ocupado por:
                                                </Typography>

                                                {
                                                    ( idEstatus === 4 || idEstatus === 5 )
                                                    &&
                                                        <Typography variant="subtitle2" sx={{ fontSize: 12, mt: 1 }}>
                                                            {usuario}
                                                        </Typography>
                                                }

                                                <Typography variant="subtitle2" sx={{ fontSize: 12, color: 'text.secondary', mt: 1 }}>
                                                    {unidad}
                                                </Typography>

                                            </CardContent>
                                    }

                                    <CardActions>

                                        {
                                            ( idEstatus === 4 || idEstatus === 5 || idEstatus === 6 )
                                            ?
                                                ( ( liberar && ( idEstatus === 4 || idEstatus === 5 ) ) || administrador )
                                                &&
                                                    <Button
                                                        fullWidth
                                                        size="small"
                                                        variant="contained"
                                                        color={ 'secondary' }
                                                        onClick={() => handleLiberarCubiculo({
                                                            idTipoCubiculo,
                                                            numeroCubiculo,
                                                            idEstatus,
                                                            unidad,
                                                            usuario,
                                                            liberar
                                                        })}
                                                    >
                                                        Liberar cubículo
                                                    </Button>
                                            :
                                                <Button
                                                    fullWidth
                                                    size="small"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={() => handleSeleccionarCubiculo({
                                                        idTipoCubiculo,
                                                        numeroCubiculo,
                                                        idEstatus,
                                                        unidad,
                                                        usuario,
                                                        liberar
                                                    })}
                                                >
                                                    Seleccionar cubículo
                                                </Button>
                                        }

                                    </CardActions>

                                </Card>

                            </Grid>

                        ))
                }

            </Grid>

            <Dialog
                maxWidth='md'
                disableEscapeKeyDown
                open={ confirmDialogOpen }
                onClose={ () => {} }
            >
                <DialogTitle>Confirmación</DialogTitle>

                <DialogContent sx={{ width: 450 }}>

                    <DialogContentText>
                        ¿Estás seguro(a) que deseas seleccionar el <strong>cubículo { cubiculoSeleccionado?.numeroCubiculo }</strong>?
                    </DialogContentText>

                    {
                        administrador
                        &&
                            <Grid container spacing={3} sx={{ mt: 3 }}>

                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl required fullWidth>

                                        <InputLabel>Unidad</InputLabel>

                                        <Select                                        
                                            label="Unidad"
                                            value={ unidadAsignacion }
                                            onChange={ (e) =>{ setUsuarioAsignacion(0); setUnidadAsignacion( parseInt(e.target.value.toString() ?? '0') ); } }
                                        >

                                            <MenuItem key={0} value={0}>Todas las unidades</MenuItem>
                                            {
                                                unidadArray.map((u) => (
                                                    <MenuItem key={u.idUnidad} value={u.idUnidad}>
                                                        {u.descripcion}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl required fullWidth>

                                        <InputLabel>Usuario(s)</InputLabel>
                                        <Select                                         
                                            label="Usuario(s)"
                                            value={usuarioAsignacion}
                                            onChange={ (e) => setUsuarioAsignacion( parseInt( e.target.value.toString() ) ) }
                                            disabled={ unidadAsignacion === 0 }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona un usuario</MenuItem>
                                            {                                            
                                                usuarioArray.map((u) => (
                                                    <MenuItem key={u.idUsuario} value={u.idUsuario}>
                                                        {u.nombre} {u.apellido1} {u.apellido2}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                            </Grid>
                    }

                </DialogContent>

                <DialogActions>
                    <Button color="secondary"  onClick={() => { setConfirmDialogOpen(false); setUnidadAsignacion(0); setUsuarioAsignacion(0); }}>
                        Cancelar
                    </Button>

                    <Button disabled={loadingFinalizar || (administrador && usuarioAsignacion === 0)} onClick={ confirmarSeleccionCubiculo } variant="contained" loading={loadingFinalizar}>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth='md'
                disableEscapeKeyDown
                open={ open }
                onClose={ () => { } }
            >

                <DialogTitle>
                    Confirmación
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        ¿Estás seguro(a) que deseas liberar el <strong>cubículo { cubiculoSeleccionado?.numeroCubiculo }</ strong>?
                    </ DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button color="secondary" onClick={ () => setOpen( false ) }> Cancelar </ Button>
                    <Button
                        variant="contained"
                        disabled={ loadingLiberar }                        
                        loading={ loadingLiberar }
                        onClick={ confirmarLiberacionCubiculo }
                >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>

    )
}


